import { render, staticRenderFns } from "./detail-incentive-registration.vue?vue&type=template&id=531bc082&scoped=true"
import script from "./detail-incentive-registration.vue?vue&type=script&lang=js"
export * from "./detail-incentive-registration.vue?vue&type=script&lang=js"
import style0 from "./detail-incentive-registration.vue?vue&type=style&index=0&id=531bc082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531bc082",
  null
  
)

export default component.exports